import React, { useState } from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from 'react-i18next';
import classes from './CustomMonthPicker.module.scss';
import { monthsShort } from '../../../utils/constants';
import colors from '../../../scss/colors';

const CustomMonthPicker = ({
  month,
  year,
  setMonth,
  setYear,
  backgroundColor = colors.PAGE_BACKGROUND,
  disabledBeforeIncluded = { month: null, year: null }
}) => {
  const { t } = useTranslation();
  const [yearToShow, setYearToShow] = useState(year);

  const monthsItems = monthsShort(t);

  const isSelected = (monthIndex) => monthIndex === month && year === yearToShow;

  const isDisabled = (monthIndex) =>
    monthIndex <= disabledBeforeIncluded.month && yearToShow <= disabledBeforeIncluded.year;

  return (
    <div className={classes.mainWrapper} style={{ backgroundColor }}>
      <div className={classes.calendarHeaderWrapper}>
        <p>{yearToShow}</p>
        <div className={classes.actionButtons}>
          {(!disabledBeforeIncluded.year || yearToShow > disabledBeforeIncluded.year) && (
            <ArrowBackIosNewIcon
              fontSize="small"
              onClick={() => setYearToShow((dateBack) => dateBack - 1)}
              sx={{ color: colors.LIGHT_GREY }}
            />
          )}
          <ArrowForwardIosIcon
            fontSize="small"
            onClick={() => setYearToShow((dateForward) => dateForward + 1)}
            sx={{ color: colors.LIGHT_GREY }}
          />
        </div>
      </div>
      <div className={classes.monthsWrapper}>
        {monthsItems.map((monthItem, monthIndex) => (
          <button
            key={`month-${monthItem}`}
            onClick={() => {
              if (!isDisabled(monthIndex)) {
                setMonth(monthIndex);
                setYear(yearToShow);
              }
            }}
            className={`${classes.calendarMonthCell} ${isSelected(monthIndex) ? classes.selected : ''} ${
              isDisabled(monthIndex) ? classes.disabled : ''
            }`}
          >
            {monthItem}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CustomMonthPicker;
